import { useCallback, useContext } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { ConfigurationContext } from "../Configuration";
import { aquireToken } from "../../../API/Authorization";
import { IUseAuthenticationPreflight } from "./IUseAuthenticationPreflight";

export function useAuthenticationPreflight(): IUseAuthenticationPreflight {
  const config = useContext(ConfigurationContext);
  const { instance } = useMsal();

  const preflightAuthentication = useCallback(async () => {
    await aquireToken(instance, config);
  }, [instance, config]);

  return {
    useIsAuthenticated: useIsAuthenticated(),
    preflightAuthentication
  };
}
